// extracted by mini-css-extract-plugin
export default {"security-info__container":"style_security-info__container__FT2q3"};